import { render, staticRenderFns } from "./discountSettingsEditor.vue?vue&type=template&id=38acdab9&scoped=true"
import script from "./discountSettingsEditor.vue?vue&type=script&lang=js"
export * from "./discountSettingsEditor.vue?vue&type=script&lang=js"
import style0 from "./discountSettingsEditor.vue?vue&type=style&index=0&id=38acdab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acdab9",
  null
  
)

export default component.exports